<main class="d-grid gap-4">
  <div class="d-flex justify-content-between align-items-center">
    <div class="page-header">
      <div
        class="d-flex align-items-center gap-3"
        style="cursor: pointer"
        (click)="goBack()"
      >
        <i class="fas fa-arrow-left back-icon"></i>
        <div class="page-title">Year Level Management</div>
      </div>
    </div>
    <app-button
      [label]="'Add Year Level'"
      [minWidth]="'12rem'"
      (clicked)="openAddYearLevel()"
    >
    </app-button>
  </div>

  <div class="table-container">
    <app-table
      [columns]="columns"
      [data]="yearLevels"
      [actionTemplate]="actionButtonsTemplate"
      [loading]="loading"
      tableName="Year Level Management"
    >
    </app-table>
  </div>
</main>

<ng-template #actionButtons let-row>
  <div class="action-buttons-container">
    <img
      class="action-button"
      (click)="onEdit(row)"
      src="assets/images/Buttons/edit-button.svg"
      alt="Edit"
      title="Edit"
    />
    <img
      class="action-button"
      (click)="onDelete(row)"
      src="assets/images/Buttons/delete-button.svg"
      alt="Delete"
      title="Delete"
    />
  </div>
</ng-template>